module.exports = __webpack_public_path__ + "i18n/de.79bc0d92774c0a661d7906b567648af9.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/de.json
// module id = 1305
// module chunks = 59